import React, { useState } from 'react';
import { Button, CircularProgress } from 'components/mui';
import { downloadSREDExcel, SREDFilters } from 'api/sred';
import { useNotificationProvider } from 'hooks';
import { SREDParams } from '../types';

interface SREDExportButtonProps {
  params: SREDParams;
}

function SREDExportButton({ params }: SREDExportButtonProps) {
  const [isDownloading, setIsDownloading] = useState(false);
  const { notifySuccess, notifyError } = useNotificationProvider();

  const handleExport = async () => {
    if (!params.startDate || !params.endDate) return;

    setIsDownloading(true);
    try {
      const filters: SREDFilters = {
        startDate: params.startDate,
        endDate: params.endDate,
        sredYear: params.sredYear,
        consultantIds: params.selectedConsultantIds.length > 0 ? params.selectedConsultantIds : undefined,
        projects: params.selectedProjects.length > 0 ? params.selectedProjects : undefined,
      };
      await downloadSREDExcel(filters);
      notifySuccess('Excel report downloaded');
    } catch (error) {
      console.error('[SREDReport] Failed to download Excel:', error);
      notifyError('Failed to download report');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Button
      variant="contained"
      onClick={handleExport}
      disabled={isDownloading || !params.startDate || !params.endDate}
      sx={{ alignSelf: 'flex-start' }}
    >
      {isDownloading ? (
        <CircularProgress size={20} sx={{ mr: 1 }} />
      ) : null}
      {isDownloading ? 'Downloading...' : 'Export to Excel'}
    </Button>
  );
}

export default SREDExportButton;
